import React from 'react';
import { FormLabel, Box, Select, MenuItem, ListItemText } from '@mui/material';

export const ClientStatusSelect = ({ clientStatus, onChange, disabled, hidelabel = false }) => {
	const options = [
		{ label: 'Current', value: true },
		{ label: 'Not Current', value: false },
	];
	return (
		<Box>
			{!hidelabel && <FormLabel>{'Current State'}</FormLabel>}
			<Select
				fullWidth
				disabled={disabled}
				value={clientStatus ?? ''}
				onChange={(event) => {
					onChange(event.target.value);
				}}
				sx={{
					display: 'flex',
					maxHeight: 35,
					alignItems: 'center',
				}}
			>
				{options.map((option) => (
					<MenuItem key={option.label} value={option.value}>
						<ListItemText primary={option.label} />
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};
